import { getApi } from './init';

class WxAuthManager {
  // 微信静默登录
  silentWxLogin(options) {
    const { redirectUri } = options;
    location.replace(
      `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${this.getAppId()}&redirect_uri=${encodeURIComponent(
        redirectUri,
      )}&response_type=code&scope=snsapi_base&state=#wechat_redirect`,
    );
  }

  isWxBrowser() {
    return /MicroMessenger/.test(window.navigator.userAgent);
  }

  // 是否需要执行微信静默登录
  isNeedSilentWxLogin() {
    const wxOpenId = this.getWxOpenId();
    return this.isWxBrowser() && !wxOpenId;
  }

  async codeToOpenId(code: string) {
    const { tcWechatApi } = getApi();
    const { openid } = await tcWechatApi.openId({
      code,
    });
    this._setWxOpenId(openid);
  }

  _setWxOpenId(openid: string) {
    if (openid) {
      localStorage.setItem('wxOpenId', openid);
    }
  }

  getAppId() {
    return 'wx586d955569e4be40';
  }

  getWxOpenId() {
    return localStorage.getItem('wxOpenId');
  }
}

let wxAuthManager;
export function getWxAuthManager() {
  if (!wxAuthManager) {
    wxAuthManager = new WxAuthManager();
  }
  return wxAuthManager;
}
